import React, { useState,useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import {Routes, Route} from 'react-router-dom'

function Calculator (props){
    return(
        <>
            <h1>Calculator Page</h1>
        </>
    )
}
export default Calculator